import { render, staticRenderFns } from "./SelectRegions.vue?vue&type=template&id=012e9630&scoped=true&"
import script from "./SelectRegions.vue?vue&type=script&lang=js&"
export * from "./SelectRegions.vue?vue&type=script&lang=js&"
import style0 from "./SelectRegions.vue?vue&type=style&index=0&id=012e9630&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012e9630",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
